export default __webpack_public_path__ + "static/media/img5.c0b10081.PNG";